<script setup>
import { logout } from '@/api/user'
import { getToken } from '@/utils/auth'
// import { useDark, useToggle } from '@vueuse/core'
// import { setLocale, locale } from '@/locales'

// const isDark = useDark()
// const toggleDark = useToggle(isDark)
// const toggleLocale = () => {
//   setLocale(locale.value == 'en' ? 'zh-cn' : 'en')
// }
const router = useRouter()
const userStore = useUserStore()
const statusStore = useStatusStore()

const toggleLeft = () => {
  statusStore.toggleStatus()
}


const isDropdown = ref(false)

const toggleLocale = () => {
  // 与路由守卫、axios 拦截器使用同一个 token 来源
  const token = getToken()
  if (token) {

    isDropdown.value = !isDropdown.value
  } else {
    showToast('未登录');
  }



}


// 点击头像展开下拉
const handleCommand = async (command) => {
  switch (command) {
    case 'logout':

      const res = await logout()
      console.log(res)
      if (res.data) {
        await userStore.logout()
        isDropdown.value = false
        showToast('退出成功');
        // 先跳到登录页再刷新，避免刷新后仍停留在首页触发自动登录
        router.replace('/login').then(() => {
          location.reload()
        })
        //
      } else {

        isDropdown.value = false
      }


      break
    case 'password':
      console.log('password')

      router.push('/userPassword')
      isDropdown.value = false

      break

  }
}



</script>

<template>
  <div class="avatar-dropdown relative">
    <van-nav-bar fixed placeholder>
      <template #left>
        <span @click="toggleLeft()"><van-icon name="wap-nav" size="20" /></span>
      </template>
      <template #title>
        <span>疗愈智能体系统</span>
      </template>
      <template #right>
        <!-- <span>{{userStore.user.name}}</span> -->

        <span class="user-avatar" @click="toggleLocale"><van-icon name="contact-o" size="20" /></span>
        <!-- <svg-icon @click="toggleLocale()" class="text-[18px] m-1" name="i18n" />
                                <svg-icon @click="toggleDark()" class="text-[18px]" :name="isDark ? 'light' : 'dark'" /> -->
      </template>
    </van-nav-bar>
    <div v-if="isDropdown" class="dropdown-menu absolute z-10 right-1 w-10">
      <div class="dropdown-item" @click="handleCommand('password')"><span>修改密码</span></div>
      <div class="dropdown-item" @click="handleCommand('logout')"><span>退出登录</span></div>

      <div class="arrow-bordered"></div>
    </div>
  </div>
</template>

<style scoped>
.user-avatar {
  display: inline-block;
  width: 30px;
  height: 30px;
  line-height: 32px;
  border: 1px solid #ccc;
  border-radius: 50%;


}

.user-avatar i {
  color: #ccc;
}

.dropdown-menu {
  border: 1px solid var(--tt-card-border);
  font-size: 14px;
  margin-top: 4px;
  border-radius: 5px;
  padding-top: 4px;
  padding-bottom: 4px;
  background-color: var(--tt-card-bg);
  color: var(--tt-text-primary);
  z-index: 999;

}

.dropdown-menu .dropdown-item {
  text-align: center;
  height: 26px;
  line-height: 26px;
}

.dropdown-menu .dropdown-item:hover {
  background-color: #e8f4ff;
  color: #1890ff;
}

.arrow-bordered {
  position: relative;
  width: 10px;
  height: 9px;
  position: absolute;
  top: -6px;
  right: 10px;
}

/* 内层白色箭头（向上） */
.arrow-bordered::after {
  content: '';
  position: absolute;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
  /* 水平居中 */
  width: 0;
  height: 0;
  /* 调整为向上箭头：左右边框透明，底部边框实心 */
  border-left: 8px solid transparent;
  border-right: 8px solid transparent;
  border-bottom: 9px solid var(--tt-card-bg);
  z-index: 1;
}

/* 外层红色描边（向上） */
.arrow-bordered::before {
  content: '';
  position: absolute;
  top: -1px;
  left: 50%;
  transform: translateX(-50%);
  /* 水平居中 */
  width: 0;
  height: 0;
  /* 调整为向上箭头：左右边框透明，底部边框实心（描边色） */
  border-left: 6px solid transparent;
  border-right: 6px solid transparent;
  border-bottom: 8px solid var(--tt-card-border);
  z-index: 0;
}
</style>
